<template>
  <OurModal v-model="isShownModal" :title="$t('promotions.type.add')" mobile-footer-reverse>
    <OurInput
      v-model="name"
      :label="$t('promotions.type._')"
      :placeholder="$t('promotions.type._')"
      :error="nameError"
    />

    <template #footer-left>
      <OurButton :text="$t('button.add')" @click="onClickApplyButton" />
      <OurButton :text="$t('button.close')" variant="secondary" @click="onClickCloseButton" />
    </template>
  </OurModal>
</template>

<script>
import { required, maxLength } from "vuelidate/lib/validators";
import apolloMixin from "@/mixins/apollo.mixin";
import { createDealerIncentiveTypeMutation } from "@/views/settings/promotions/add/gql/mutations";
import { PROMOTION_NAME_MAX_LENGTH } from "@/views/settings/promotions/add/constants";

export default {
  name: "AddPromotionTypeModal",

  mixins: [apolloMixin],

  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      name: "",
    };
  },

  validations: {
    name: {
      required,
      maxLength: maxLength(PROMOTION_NAME_MAX_LENGTH),
    },
  },

  computed: {
    isShownModal: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },

    nameError() {
      if (!this.$v.name.$dirty) {
        return "";
      }

      if (!this.$v.name.required) {
        return this.$t("validation.required");
      }

      if (!this.$v.name.maxLength) {
        return this.$t("validation.textMaxLength", { length: PROMOTION_NAME_MAX_LENGTH });
      }

      return "";
    },
  },

  watch: {
    show(value) {
      if (!value) {
        this.name = "";
        this.$v.$reset();
      }
    },
  },

  methods: {
    closeModal() {
      this.isShownModal = false;
    },

    onClickCloseButton() {
      this.closeModal();
    },

    async onClickApplyButton() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      const { createDealerIncentiveType } = await this.$post(createDealerIncentiveTypeMutation, {
        name: this.name.trim(),
      });

      if (createDealerIncentiveType?.id) {
        this.$emit("created", createDealerIncentiveType);
        this.closeModal();
      }
    },
  },
};
</script>
